import { createListenerMiddleware } from '@reduxjs/toolkit';
import {
  ACCOUNT_FEATURE,
  createListenerEffect,
  FEATURE_TYPE,
  isNumber,
  selectAccountId,
  selectFeatureTypes,
} from '@socialive/common';
import { selectSplitAttributes, selectSplitStatus } from '~/selectors';
import { getTreatments } from '~/thunks';

export const effect = createListenerEffect(
  'features/loadSplitsForAccounts<Listener>',
  async (action, { dispatch, getState, trigger }) => {
    const accountId = selectAccountId(getState());

    await dispatch(
      getTreatments({
        splitNames: Object.values(ACCOUNT_FEATURE),
        key: accountId,
        attributes: selectSplitAttributes(getState()),
        trigger,
      })
    );
  }
);

let cache;
export const predicate = (action, state) => {
  const enabled = selectFeatureTypes(state);
  if (enabled[FEATURE_TYPE.ACCOUNT]) {
    const { accountId, userId } = selectSplitAttributes(state);
    const split = selectSplitStatus(state);
    if (split.complete && isNumber(accountId) && isNumber(userId) && accountId !== cache) {
      cache = accountId;
      return true;
    }
  }
  return false;
};

const { startListening, middleware } = createListenerMiddleware();

startListening({
  predicate,
  effect,
});

export default middleware;
